<template>
  <div type="flex" class="controlsContainer">
    <div class="cropActionsContainer">
      <el-row>
        <!-- Zoom panel -->
        <el-col
          type="flex"
          justify="start"
          :xl="{ span: 16, offset: 4 }"
          :lg="{ span: 16, offset: 4 }"
          :md="{ span: 16, offset: 4 }"
          :sm="{ span: 22, offset: 1 }"
          :xs="{ span: 22, offset: 1 }"
        >
          <div class="timelineScaleContainer">
            <div class="timelineScaleHeader marginScaleHeader">
              Timeline Zoom
            </div>
            <div class="timelineScaleScroll">
              <zoom-in-icon
                class="zoom-control-btn"
                title="Zoom In (Q)"
                @click="zoomIn"
              />
              <vue-slider
                class="zoomScroll"
                :value="currentZoom"
                :min="0.01"
                :max="1"
                :interval="0.01"
                tooltip="active"
                :tooltip-formatter="zoomFormatter"
                :dot-style="{ height: '20px' }"
                @drag-start="dragingFlag = true"
                @change="setZoom"
                @drag-end="applyZoom"
              >
                <template v-slot:dot>
                  <div class="zoom-pointer"></div>
                </template>
              </vue-slider>
              <zoom-out-icon
                class="zoom-control-btn"
                title="Zoom Out (W)"
                @click="zoomOut"
              />
            </div>
          </div>
        </el-col>
        <!-- Trim & Preview -->
        <el-col
          type="flex"
          justify="center"
          :xl="{ span: 24, offset: 0 }"
          :lg="{ span: 24, offset: 0 }"
          :md="{ span: 24, offset: 0 }"
          :sm="{ span: 22, offset: 1 }"
          :xs="{ span: 22, offset: 1 }"
        >
          <div class="timelineScaleContainer">
            <div class="timelineScaleHeader">
              Timeline Actions
            </div>
            <div class="timelineActionsRow">
              <el-button
                v-if="channelType !== 'audio'"
                class="trimEndShareButton trimEndShareButtonHower"
                title="Trim & Share"
                type="danger"
                size="medium"
                @click="sendCropEndTrimRequest"
              >
                <div class="control-content">
                  <crop-icon class="control-icon" />
                  Trim & Share
                </div>
              </el-button>
              <el-button
                :disabled="disabledTrimBtn"
                class="timelineActionButton"
                title="Trim Clip"
                type="danger"
                size="medium"
                @click="sendCropRequest"
              >
                <div class="control-content">
                  <crop-icon class="control-icon" />
                  Trim
                </div>
              </el-button>
              <el-button
                class="timelineActionButton"
                type="success"
                title="Preview Clip"
                size="medium"
                @click="showPreview"
              >
                <div class="control-content">
                  <monitor-icon class="control-icon" />
                  Preview (P)
                </div>
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
/** video clips controls icons */
/** slider for scale video */
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { mapState, mapGetters, mapActions } from "vuex";

/** shortcuts */
import { subscribeToKeydown, subscribeToKeyup } from "@/utils/shortcuts.js";

/** icons */
import ZoomInIcon from "vue-material-design-icons/MagnifyPlusOutline.vue";
import ZoomOutIcon from "vue-material-design-icons/MagnifyMinusOutline.vue";
import CropIcon from "vue-material-design-icons/Crop.vue";
import MonitorIcon from "vue-material-design-icons/Monitor.vue";

// @group Media/Controls
// Trim & zoom panel
export default {
  components: {
    /** timeline scale */
    VueSlider,
    /** icons */
    ZoomInIcon,
    ZoomOutIcon,
    CropIcon,
    MonitorIcon
  },
  props: {
    mediaItems: {
      type: Object
    }
  },
  data() {
    return {
      dragingFlag: false,
      // Zoom percents parameter
      timelineInterval: 1,
      zoomFormatter: v => `${Math.round(v * 100)}%`,

      /** zooming parameters */
      zoomStep: 0.1,
      zoomChangeInterval: 100,
      zoomOutHolding: false,
      zoomInHolding: false,
      boundedZoom: 1,
      disabledTrimBtn: false
    };
  },
  watch: {
    mediaItems() {
      // if (this.mediaItems.clips || this.mediaItems.audios) {
      //   if (
      //     this.mediaItems.clips.length < 1 ||
      //     this.mediaItems.audios.length < 1
      //   ) {
      //     this.disabledTrimBtn = false;
      //   }
      // }
      if (this.mediaItems.clips) {
        if (this.mediaItems.clips.length < 1) {
          this.disabledTrimBtn = false;
        }
      }
      if (this.mediaItems.audios) {
        if (this.mediaItems.audios.length < 1) {
          this.disabledTrimBtn = false;
        }
      }
      if (this.mediaItems.clips) {
        this.mediaItems.clips.map(e => {
          if (
            e.status === "ready" ||
            e.status === "failed" ||
            e.status === "remote"
          ) {
            this.disabledTrimBtn = false;
          } else {
            this.disabledTrimBtn = true;
          }
        });
      }
      if (this.mediaItems.audios) {
        this.mediaItems.audios.map(e => {
          if (
            e.status === "ready" ||
            e.status === "failed" ||
            e.status === "remote"
          ) {
            this.disabledTrimBtn = false;
          } else {
            this.disabledTrimBtn = true;
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters(["channelType"]),
    ...mapState({
      currentZoom: state => state.timeline.zoom,
      modals: state => state.modals.clipper.MODALS,
      openedModal: state => state.modals.clipper.opened,
    })
  },
  mounted() {
    /** shortcuts subscribing */

    /** preview */
    subscribeToKeydown("KeyP", () => {
      if (this.openedModal == null) {
        this.showPreview();
      }
    });

    /** zoom increasing */
    subscribeToKeydown("KeyQ", () => this.startZoomDecreasing());
    subscribeToKeyup("KeyQ", () => this.stopZoomDecreasing());

    /** zoom decreasing */
    subscribeToKeydown("KeyW", () => this.startZoomIncreasing());
    subscribeToKeyup("KeyW", () => this.stopZoomIncreasing());
  },
  methods: {
    ...mapActions("timeline", ["sendCrop", "zoom"]),
    ...mapActions("modals", ["openClipperModal", "closeClipperModal"]),
    // @vuese
    // Clip stream fragment selected by clipping borders on timeline
    async sendCropRequest() {
      this.disabledTrimBtn = true;
      // "Trim" button clicked
      this.$emit("sendCrop");
    },
    async sendCropEndTrimRequest() {
      // "Trim & Share" button clicked
      this.$emit("sendCrop", true);
    },
    // @vuese
    // Show video preview modal
    showPreview() {
      this.openClipperModal({
        modal: this.modals.PREVIEW,
        data: null
      });
    },
    applyZoom() {
      this.zoom({ value: this.boundedZoom });
      if (this.dragingFlag) {
        this.dragingFlag = false;
      }
    },
    // @vuese
    // Set new bounded and rounded zoom value
    // @arg newValue - new zoom value
    setZoom(newValue) {
      this.boundedZoom = Math.min(Math.max(newValue, 0.01), 1);
      const perc = (newValue * 100) % 4;
      if (!this.dragingFlag) {
        this.applyZoom();
      }
      if (perc == 0) {
        this.applyZoom();
        this.dragingFlag = true;
      }
    },
    // @vuese
    // Increase zoom by one step
    zoomOut() {
      const newValue = this.currentZoom * (1 + this.zoomStep);
      this.setZoom(newValue);
    },
    // @vuese
    // Decrease zoom by one step
    zoomIn() {
      const newValue = this.currentZoom / (1 + this.zoomStep);
      this.setZoom(newValue);
    },
    // @vuese
    // Start zoom increasing proccess
    startZoomIncreasing() {
      if (!this.zoomOutHolding) {
        this.zoomOutHolding = true;
        this.zoomOutRecursively();
      }
    },
    // @vuese
    // Stop zoom increasing process
    stopZoomIncreasing() {
      this.zoomOutHolding = false;
    },
    // @vuese
    // Increase zoom and call this method after timeout
    zoomOutRecursively() {
      if (this.zoomOutHolding) {
        this.zoomOut();
        setTimeout(() => this.zoomOutRecursively(), this.zoomChangeInterval);
      }
    },
    // @vuese
    // Start zoom decreasing proccess
    startZoomDecreasing() {
      if (!this.zoomInHolding) {
        this.zoomInHolding = true;
        this.zoomInRecursively();
      }
    },
    // @vuese
    // Stop zoom decreasing process
    stopZoomDecreasing() {
      this.zoomInHolding = false;
    },
    // @vuese
    // Decrease zoom and call this method after timeout
    zoomInRecursively() {
      if (this.zoomInHolding) {
        this.zoomIn();
        setTimeout(() => this.zoomInRecursively(), this.zoomChangeInterval);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.cropActionsContainer {
  display: block;
  // padding: 10px 0;
  /* vertical-align: middle;
   padding: 25px; */
}
.timelineScaleContainer {
  margin: 7px;
}
.timelineScaleHeader {
  margin: 7px;
}
.timelineScaleScroll {
  display: flex;
  justify-content: space-between;
}
.zoomScroll {
  width: 100% !important;
  margin-right: 10px;
  margin-left: 10px;
}
.zoom-pointer {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  background-color: white;
  cursor: pointer;

  @media (pointer: fine) {
    height: 16px;
    width: 16px;
  }
  @media (pointer: coarse) {
    height: 24px;
    width: 24px;
  }
}
.zoom-control-btn {
  margin-top: -8px;
  color: #dfdfdf;
  cursor: pointer;

  .material-design-icon__svg {
    display: block; // icon can be bigger than container

    @media (pointer: fine) {
      width: 24px;
      height: 24px;
    }
    @media (pointer: coarse) {
      width: 32px;
      height: 32px;
    }
  }
}

.trimEndShareButtonHower:hover {
  background: #c68e39;
  border-color: #c68e39;
  color: #ffffff;
}

.marginScaleHeader {
  padding: 0 0 10px 0;
}

.zoom-control-btn:hover {
  color: white;
}

.trimEndShareButton {
  background-color: #e6a23c;
  border: none;
}
.control-content {
  display: flex;
  justify-content: center;
}
.control-icon {
  margin-right: 5px;
  .material-design-icon__svg {
    width: 14px;
    height: 14px;
  }
}
.cropButton {
  padding-top: 5px;
  padding-bottom: 5px;
  left: 0;
}
@media only screen and (max-width: 640px) {
  .timelineActionsRow {
    display: flex;
  }
  .timelineActionButton {
    flex-grow: 1;
  }
}

@media only screen and (max-width: 767px) {
  .timelineScaleHeader {
    font-size: 16px;
  }
}

@media only screen and (min-width: 768px) {
  .timelineScaleHeader {
    font-size: 14px;
  }
}

@media only screen and (min-width: 992px) {
  .timelineScaleHeader {
    font-size: 12px;
  }
}
@media only screen and (min-width: 1200px) {
  .timelineScaleHeader {
    font-size: 14px;
  }
  .cropActionsContainer {
    margin-top: 30px;
  }
}

@media only screen and (min-width: 1920px) {
  .timelineScaleHeader {
    font-size: 17px;
  }
}
</style>
